const React = require('react');

//Component is deprecated, mocking a component here just in case it's used in an obscure way that we've missed.
//TODO - Remove in a future commit.
const AutoCompleteEditor = props => {
  console.warn('Using a deprecated component (AutoCompleteEditor) - Use a different Editor', props);

  return null;
};

module.exports = AutoCompleteEditor;
